import { AsyncPipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  inject,
  OnDestroy,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FlowLinesService } from '@app/features/app-publishing/services/flow-lines.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { PlatformPublishing } from '../../models/publishing.model';
import { PublishingState } from '../../states/publishing.state';
import { IosPublishingEmptyStateComponent } from '../ios-publishing-empty-state/ios-publishing-empty-state.component';
import { IosScreenshotComponent } from '../ios-screenshot/ios-screenshot.component';
import { PlatformPublishingShellComponent } from '../platform-publishing-shell/platform-publishing-shell.component';
import { PublishingStepComponent } from '../publishing-step/publishing-step.component';

@Component({
  selector: 'rk-ios-publishing-card',
  imports: [
    FontAwesomeModule,
    PlatformPublishingShellComponent,
    PublishingStepComponent,
    AsyncPipe,
    IosPublishingEmptyStateComponent,
    IosScreenshotComponent,
  ],
  templateUrl: './ios-publishing-card.component.html',
  styleUrl: './ios-publishing-card.component.scss',
})
export class IosPublishingCardComponent implements AfterViewInit, OnDestroy {
  iosPublishingData$: Observable<PlatformPublishing> = inject(Store).select(
    PublishingState.iosPublishingData,
  );
  noIosPublishingData$: Observable<boolean> = inject(Store).select(
    PublishingState.noIosPublishingData,
  );
  iosScreenshot$: Observable<string> = inject(Store).select(
    PublishingState.iosScreenshot,
  );
  @ViewChildren(PublishingStepComponent)
  stepComponents!: QueryList<PublishingStepComponent>;
  appStoreLink$: Observable<string> = inject(Store).select(PublishingState.appStoreLink);
  private readonly subscription = new Subscription();
  private readonly flowLinesService = inject(FlowLinesService);

  ngAfterViewInit() {
    this.flowLinesService.updateFlowLines(this.stepComponents);

    this.subscription.add(
      this.stepComponents.changes.subscribe(() => {
        setTimeout(() => this.flowLinesService.updateFlowLines(this.stepComponents), 100);
      }),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
